import { render, staticRenderFns } from "./MarketplaceTabList.vue?vue&type=template&id=1d82a1e8"
import script from "./MarketplaceTabList.vue?vue&type=script&lang=js"
export * from "./MarketplaceTabList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports